import React from "react";
import { Row, Col, Card, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import mainImage from "../../assets/bloom-main.jpg"; // ✅ Bloom main image
import card1 from "../../assets/heroes-cup.jpg";     // ✅ Smaller card
import card2 from "../../assets/jui-news-image.png";            // ✅ Jiu-jitsu now moved to small card

const { Title, Paragraph, Text } = Typography;

const BloomNewsDetail = () => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate("/news");
  };

  const handleHeroesCupClick = () => {
    navigate("/news/heroes-day");
  };

  const handleJiuJitsuClick = () => {
    navigate("/news/jiu-jitsu");
  };

  return (
    <div style={{ background: "#fafafa", padding: "24px" }}>
      <Row gutter={[24, 24]} justify="center">
        {/* LEFT SIDE */}
        <Col xs={24} md={8} lg={6}>
          {/* Header Card */}
          <Card
            style={{
              background: "#4b007d",
              color: "#fff",
              borderRadius: "10px",
              padding: "16px",
            }}
            bordered={false}
          >
            <Title level={4} style={{ color: "#fff", marginBottom: 4 }}>
              Yalla Nellab News
            </Title>
            <Text 
              style={{ color: "#d9d9d9", cursor: "pointer" }}
              onClick={handleViewAll}
            >
              View all
            </Text>
          </Card>

          {/* News Card 1 - Heroes Cup */}
          <Card
            hoverable
            onClick={handleHeroesCupClick}
            cover={
              <img
                alt="Heroes Cup"
                src={card1}
                style={{ height: 140, objectFit: "cover" }}
              />
            }
            style={{ marginTop: 16, borderRadius: 10, cursor: "pointer" }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              Heroes Cup: Tournament dedicated to honoring laborers
            </Title>
            <Text type="secondary" style={{ fontSize: 13 }}>
              Read More →
            </Text>
          </Card>

          {/* News Card 2 - Jiu-jitsu */}
          <Card
            hoverable
            onClick={handleJiuJitsuClick}
            cover={
              <img
                alt="Jiu-jitsu"
                src={card2}
                style={{ height: 140, objectFit: "cover" }}
              />
            }
            style={{ marginTop: 16, borderRadius: 10, cursor: "pointer" }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              Jiu-jitsu is Rising in the UAE
            </Title>
            <Text type="secondary" style={{ fontSize: 13 }}>
              Read More →
            </Text>
          </Card>
        </Col>

        {/* RIGHT SIDE — Bloom Day Article */}
        <Col xs={24} md={16} lg={18}>
          <div
            style={{
              borderRadius: 10,
              overflow: "hidden",
              position: "relative",
            }}
          >
            <img
              alt="Bloom Day"
              src={mainImage}
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                opacity: 0.95,
              }}
            />

            {/* Article content */}
            <div
              style={{
                background: "#fff",
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                padding: "24px",
                marginTop: "8px",
              }}
            >
              <Title level={3}>Bloom Day: Yalla Nellab Announces a New Initiative for Special Children</Title>

              <Title level={5}>A Celebration of Inclusion and Happiness</Title>
              <Paragraph>
                Yalla Nellab proudly hosted <b>Bloom Day</b>, a heartwarming event dedicated to
                special children and their families, celebrating inclusion, happiness, and the power
                of community. The day was filled with laughter, outdoor activities, and memorable
                moments that brought families together in a spirit of joy and connection.
              </Paragraph>

              <Title level={5}>Fun and Engaging Outdoor Activities</Title>
              <Paragraph>
                Held in a welcoming and fun-filled environment, Bloom Day offered a range of outdoor
                games, creative workshops, and interactive sessions designed to encourage
                participation and teamwork. Children enjoyed engaging in playful challenges while
                families bonded through shared experiences — from friendly competitions to moments
                of relaxation and celebration.
              </Paragraph>

              <Title level={5}>Empowerment Through Togetherness</Title>
              <Paragraph>
                The event's purpose went beyond recreation as it focused on empowerment, awareness,
                and togetherness. Yalla Nellab aimed to create a safe and inclusive space where
                every child could shine and every family could feel supported and valued.
              </Paragraph>

              <Title level={5}>A Day Filled With Smiles and Memories</Title>
              <Paragraph>
                As smiles bloomed across the field, Bloom Day became more than just an event — it
                reminded everyone that every child deserves joy, acceptance, and a chance to be part
                of something special.
              </Paragraph>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BloomNewsDetail;